import { RadioGroupWUT } from '@wix/form-fields/viewer-wut';

export default RadioGroupWUT;
